import detectBrowser from '../__utils/detectBrowser';
import vhUnit from '../__utils/vhUnit';
import video from '../__utils/video';
import smoothScroll from '../__utils/smoothScroll';
import Header from '../__header/Header';
import HeaderMobile from '../__header/HeaderMobile';
import Search from '../__page/Search';
import MegaMenu from '../__header/MegaMenu';
import MenuMobile from '../__header/MenuMobile';
import InpageNav from '../__page/InpageNav';
import Tables from '../__utils/Tables';
import forms from '../__utils/forms';
import { SimpleSlider, LightboxSlider, HeroSlider, HeroNewsSlider, FactsSlider, HeroEventsSlider, UpcomingGamesSlider, RelatedEventsSlider } from '../__utils/Sliders';
import LogosSlider from '../__page/LogosSlider';
import Accordion from '../__shortcodes/Accordions';
import Tabs from '../__page/Tabs';
import GalleryLightbox from '../__page/LightboxGallery';
import HeroBackgroundVideo from '../__page/HeroBackgroundVideo';
import LightboxVideo from '../__page/LightboxVideo';
import CYEAccordion from '../__page/CYEAccordion';
import postsFilters from '../__archive/PostsAjax';
import eventsFilters from '../__archive/EventsAjax';
import ImageLinksSlider from '../__page/ImageLinksSlider';
import ScoreboardSlider from '../__page/ScoreboardSlider';
import GivingImageLinksSlider from '../__page/GivingImageLinksSlider';
import DonorBlockSlider from '../__page/DonorBlockSlider';
import givingForm from '../__utils/givingForm';
import GoalCards from '../__page/goalCards';
import GoalProgressCards from '../__page/goalProgressCards';
import charts from '../__page/charts';
import chartsBlock from '../__page/chartsBlock';
import sectionsInView from "../__page/sectionsInView";

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        document.querySelector('html').classList.remove('no-js');
        detectBrowser();
        smoothScroll();
        vhUnit();
        Header.init();
        HeaderMobile.init();
        Search.init();
        MegaMenu.init();
        MenuMobile.init();
        InpageNav.init();
        CYEAccordion.init();
        video.init();
        Accordion.init();
        Tabs.init();
        HeroSlider.init();
        SimpleSlider.init();
        LightboxSlider.init();
        HeroNewsSlider.init();
        HeroEventsSlider.init();
        LogosSlider.init();
        FactsSlider.init();
        GalleryLightbox.init();
        Tables.init();
        HeroBackgroundVideo.init();
        LightboxVideo.init();
        postsFilters.init();
        eventsFilters.init();
        ImageLinksSlider.init();
        ScoreboardSlider.init();
        UpcomingGamesSlider.init();
        RelatedEventsSlider.init();
        GivingImageLinksSlider.init();
        DonorBlockSlider.init();
        forms.hubspot();
        GoalCards.init( 'Gotham' );
        GoalProgressCards.init( 'Gotham' );
        charts();
        chartsBlock();
        sectionsInView();
    },
    loaded() {
        document.querySelector('body').classList.add('page-has-loaded');
        vhUnit();
        HeroBackgroundVideo.init();
    },
    scrolled() {
        InpageNav.scrolled();
    },
    resized() {
        vhUnit();
        Header.resized();
        HeaderMobile.resized();
        Search.resized();
        InpageNav.scrolled();
        Tables.toggleShadow();
        Tabs.toggleShadow();
        HeroBackgroundVideo.resized();
        HeroSlider.refresh();
        SimpleSlider.refresh();
        LightboxSlider.refresh();
        HeroNewsSlider.refresh();
        LogosSlider.refresh();
        FactsSlider.refresh();
        ImageLinksSlider.resized();
        ScoreboardSlider.resized();
        UpcomingGamesSlider.refresh();
        GivingImageLinksSlider.resized();
        DonorBlockSlider.resized();
        GoalCards.transformCards();
        GoalProgressCards.transformCards();
    },
    mouseUp(e) {
        Search.hideOutsideClick(e);
        InpageNav.hideOutsideClick(e);
    },
    keyDown(e){
        Header.keyDown(e);
        Search.keyDown(e);
        LightboxVideo.keyDown(e);
        GalleryLightbox.keyDown(e);
    },
    gformRender() {
        forms.select();
        givingForm.init();
    },
};
export default controller;
